// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__1ECFc","error":"Textarea_error__1di7U","borderless":"Textarea_borderless__8uEee"};